import * as React from "react";
import { TextInput, BooleanInput } from "react-admin";
import { Box, Card, CardContent, Grid, Typography } from "@material-ui/core";

const ReleaseTypeCreateForm = () => {
  return (
    <div>
      <Card>
        <CardContent>
          <Box display={{ md: "block", lg: "flex" }}>
            <Box flex={2}>
              <Grid container direction="row" justify="space-between" alignItems="flex-start">
                <Typography variant="h6" gutterBottom color="primary">
                  Creation Information
                </Typography>
                <BooleanInput label="Active/Passive" source="isActive" />
              </Grid>
              <Box display={{ xs: "block", sm: "flex" }}>
                <Box flex={1} mr={{ xs: 0, sm: "0.5em" }}>
                  <TextInput source="releaseTypeCode" label="RELEASE TYPE CODE" fullWidth />
                </Box>
                <Box flex={1} mr={{ xs: 0, sm: "0.5em" }}>
                  <TextInput source="releaseTypeName" label="RELEASE TYPE NAME" fullWidth />
                </Box>
              </Box>
            </Box>
          </Box>
        </CardContent>
      </Card>
    </div>
  );
};

export default ReleaseTypeCreateForm;
